import { StateShortname } from './getUsaStates/index'


type Address = {
  firstName: string
  lastName: string
  street: string
  apt: string
  zipCode: string
  city: string
  state: StateShortname
  country: 'United States'
  telephone?: string
}

type AddressTypes = 'shipping' | 'billing'

type ShippingFlatAddress = {
  shippingFirstName: string
  shippingLastName: string
  shippingStreet: string
  shippingApt: string
  shippingZipCode: string
  shippingCity: string
  shippingState: StateShortname
  shippingCountry: 'United States'
}

type BillingFlatAddress = {
  billingFirstName: string
  billingLastName: string
  billingStreet: string
  billingApt: string
  billingZipCode: string
  billingCity: string
  billingState: StateShortname
  billingCountry: 'United States'
}

const _addPrefixToAddressFields = (prefix: AddressTypes, obj: Partial<Address>) => {
  const mapObj: Partial<ShippingFlatAddress | BillingFlatAddress> = {}

  Object.keys((obj || {})).forEach((key: keyof Address) => {
    if (key !== 'telephone') {
      mapObj[`${prefix}${key.replace(/\b\w/g, (letter) => letter.toUpperCase())}`] = obj[key]
    }
  })

  return mapObj
}

type GetPrefixedInput = {
  [key in AddressTypes]: Partial<Address>
}

type GetPrefixedOutput = ShippingFlatAddress & BillingFlatAddress & {
  telephone?: string
}

/**
 * Prefix address fields except 'telephone'
 */
const getPrefixedAddressFields = ({ shipping = {}, billing = {} }: GetPrefixedInput): Partial<GetPrefixedOutput> => ({
  ..._addPrefixToAddressFields('shipping', shipping),
  ..._addPrefixToAddressFields('billing', billing),
  // backend expects not prefixed 'telephone' field
  telephone: shipping.telephone || billing.telephone,
})

export default getPrefixedAddressFields
